// extracted by mini-css-extract-plugin
export default {"logout":"LogoutPage_logout__sFBNC"};